import { useQuery } from '@apollo/client';
import {SHIPPING_METHODS} from "../productTypeDefs";

export const useQueryShippingMethods = (options?: any): any => (
  useQuery(SHIPPING_METHODS, options)
);
